import React from "react";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";

/**
 * Stellt eine Schaltfläche dar
 * @param id die ID der Komponente
 * @param variant "text" | "outlined" | "contained"
 * @param label Der anzuzeigende Text
 * @param loading wenn true, wird ein Spinner anstatt des Texts angezeigt.
 * @param rest u.A.:
 * <ul>
 *     <li> color="primary"</li>
 * </ul>
 * @returns {JSX.Element}
 * @constructor
 */
function EAButton({ id, variant = "contained", label, loading, ...rest }) {
    return (
        <Button id={id} variant={variant} {...rest}>
            {loading ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <span style={{ color: "transparent" }}>{label}</span>
                    <CircularProgress style={{ height: 15, width: 15, position: "absolute" }} />
                </div>
            ) : (
                label
            )}
        </Button>
    );
}

EAButton.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.node,
};

export default EAButton;
